import { defaultSystemCodeAddress, exists, SystemCodeAddress } from '@/api'

export interface OldAddress {
  id: number
  addressCode: SystemCodeAddress
  address: string
}

export function OldAddressFromJSON(json: any): OldAddress {
  return {
    id: json.id,
    addressCode: exists(json, 'address_code')
      ? json.address_code
      : defaultSystemCodeAddress(),
    address: exists(json, 'address') ? json.address : ''
  }
}

export function OldAddressToJSON(value: OldAddress): any {
  return {
    id: value.id,
    address_code: value.addressCode.code,
    address: value.address
  }
}
